<template>
    <!-- 下划线设置组件
        @author: liuguisheng
        @date: 2019-11-21
    -->
    <div class="setting-item">
    <el-form-item label="文字大小(字号)"> 
        <el-input-number v-model.number="fontSize" 
                       class="setting-render_indent"
                       controls-position="right"
                       placeholder="请输入文字大小"
                       :min="12" 
                       :max="100">
        </el-input-number>
    </el-form-item>
  </div>
</template>
<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 文字大小
     *  @description 将 fontSize 字段映射到当前 fontSize 计算属性
     *  @return { Number }
     *  @author 王汝鹏
     *  @version 2019-12-08
     */
    ...mapComputed({
      fontSize: { 
        parent: i => i.renderOption,
        attr: "fontSize"
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderFontSize.vue